import { frontendURL } from '../../../../helper/URLHelper';

const intelligenceDashboard = accountId => ({
  parentNav: 'intelligenceDashboard',
  routes: ['intelligence_dashboard'],
  menuItems: [
    {
      icon: 'data-pie',
      label: 'INTELLIGENCE_DASHBOARD',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/intelligence-dashboard`
      ),
      toStateName: 'intelligence_dashboard',
    },
  ],
});

export default intelligenceDashboard;
